/**
 * @file 站点配置
 * @date 2021-06-24
 */

import { ENV } from '@/config/env';
import localesConfig from '@/locales/config';

/**
 * 主推网址，用于 SEO 输出
 */
export const url = 'https://www.bybit.com';

/**
 * 当前项目支持的语言列表
 *
 * @type {Array}
 */

export const locales = localesConfig;

/**
 * 从右向左布局的语言
 */

export const RTL_LOCALES = [
    'ar-SA',
];

/**
 * 默认语言，兜底语言
 *
 * @type {string}
 */
export const locale = 'en';

/**
 * localStorage 国际化标识，注意：其她业务在英文下是 `en`
 */
export const LOCALE_LS_KEY = 'BYBIT_LANG_KEY';

/**
 * Cookie token 标识
 */
export const TOKEN_COOKIE_KEY = `b_t_c_k${ENV === 'prd' ? '' : `_${ENV}`}`;

/**
 * 交易所ID
 */
export const EXCHANGE_ID = 301;

/**
 * 资产隐藏时的显示
 */
export const HIDE_ASSET_VALUE = '********';

/**
 * Cookie guid key
 */
export const BYBIT_GUID_KEY = '_by_l_g_d';

// 公告版本号
export const NOTICE_VERSION = 'SPOT_notice_version';

/**
 * 法币 充值支持 弹窗 cookie key
 */
export const SPOT_FIAT_WITHDRAW_TIPS_COOKIE_KEY = 'spot_fiat_withdraw_c_k';

/**
 * LT 常规警告控制 cookie key
 */
export const SPOT_LT_TIPS_COOKIE_KEY = `lt_c_k${ENV === 'prd' ? '' : `_${ENV}`}`;

/**
 * 全仓杠杆 开通提示 localstorage key
 */
export const SPOT_LEVERAGE_TIPS_KEY = `lr_l_s${ENV === 'prd' ? '' : `_${ENV}`}`;

/**
 * LT介绍 urlMap
 */
export const LT_URL_ID = '000001603';

/**
 * 全仓杠杆手册 urlMap
 */
export const LEVERAGE_URL_ID = '000001617';

/**
 * 现货交易费率
 */
export const LEVERAGE_RATE_URL_ID = '000001175';

/**
 * 通证管理规则
 */
export const ST_URL_ID = '000001612';

/**
 * IMC团队的广告商推广 cookie key
 */
export const DX_ID = '35CJa4376';
export const DX_CP = '35CJa4376-cp';

/**
 * 静态资源路径
 */
export const ASSETS_DIR = 'spot-fe-loan/trade/spot/pro/static';

// 全局配置localstorage key
export const LS_GLOBAL_SETTING = 'SPOT_setting';
